export default __webpack_public_path__ + "static/media/refresh_dark_accent.f3b726fd.svg";